module.exports = __webpack_public_path__ + "static/googleplay-34c50378848ac49c12e4bfe5b76d3b6c.png";